<template>
  <div>
    <CardForm :card-form-data="getCardInfo(formData, true)" />
    <CardForm
      v-for="(member, index) in formData.familyMembers"
      :key="index"
      :card-form-data="getCardInfo(member, false, index + 2)"
    />
  </div>
</template>

<script>
import CardForm from './CardForm.vue'

import moment from 'moment'
export default {
  name: 'MemberCard',
  components: {
    CardForm,
  },
  props: {
    summary: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      formData: this.$formData,
      optionData: this.$optionData,
    }
  },
  computed: {},
  watch: {
    summary: function (value) {
      // Object.assign(this.summary, value)
      this.summary = { ...value }
    },
  },
  mounted() {},
  methods: {
    getCardInfo(formData, isPolicy = false, reference = 1) {
      let detail = null
      if (isPolicy) {
        detail = formData.policyHolder.details
      } else {
        detail = formData.details
      }

      let policyStartDate = this.getValidDate(this.formData)

      let result = {
        titleFullName: this.getInsuredPerson(detail, this.optionData),
        policyNumber: this.getPolicyNumber(this.formData, reference),
        productName: this.getProductName(),
        levelCoverName: this.getLevelOfCoverName(),
        validFrom: policyStartDate.from,
        validTo: policyStartDate.to,
        excessWithSymbol: this.getExcessWithSymbol(),
        residentCountryName: this.getCountryName(this.formData, this.optionData),
      }
	  
      return result
    },

    getInsuredPerson(detail, optionData) {
      // let detail = formData.policyHolder.details
      let title = ''
      if (detail.salutationId) {
        title = optionData.titles.find((v) => detail.salutationId && v.value == detail.salutationId).text || ''
      }

      let name = `${detail.forename} ${detail.surname}`
      return `${title} ${name}`
    },

    getPolicyNumber(formData, reference) {
      return `${formData.policyNumber}/${reference}`
    },

    getProductName() {
      return this.summary.productSelected.productName
    },

    getLevelOfCoverName() {
      return this.summary.levelOfCover.levelOfCoverName
    },

    getValidDate(formData) {
      return {
        from: moment(formData.policyDetails.policyStartDate).format('DD/MM/YYYY'),
        to: moment(formData.policyDetails.policyStartDate).add(1, 'years').add(-1, 'days').format('DD/MM/YYYY'),
      }
    },
    getExcessWithSymbol() {
      let currency = this.summary.currency
      let result = `${currency}${this.summary.voluntaryExcessSelected.voluntaryExcessName}`
      return result
    },
    getCountryName(formData, optionData) {
      var countryName = optionData.residenceCountries.find((v) => v.value == formData.policyHolder.details.residenceCountryId).text || ''
      return countryName
    },
  },
}
</script>
